{
    "age_verification": {
        "title": "Welcome!",
        "message": "Are you {{minAge}} years old or older?",
        "button": "Enter",
        "error_message": "You must be {{minAge}} years old or older to view this content.",
        "button_reset": "Back"
    },

    "welcome": {
        "title": "Welcome!",
        "description": ""
    },

    "unknown": {
        "title": "Unknown Page",
        "description": "The page you are trying to reach does not exist or is not available."
    },

    "preview": {
        "text": "This is a preview and is only temporarily available."
    },

    "cookies": {
        "title": "Cookies",
        "description": "This website uses cookies to enhance the user experience. By continuing, you agree to our cookie policy.",
        "button_accept_all": "Accept All",
        "button_decline_all": "Decline All",
        "button_show_preferences": "Show Preferences",
        "button_save_preferences": "Save Preferences",
        "button_close": "Close",

        "sections": {
            "introduction": {
                "title": "Preferences Menu",
                "description": "This website uses cookies to enhance the user experience. Cookies are small text files that are stored on your device when you visit our website. They help us understand how you use our site and allow us to improve functionality and performance."
            },

            "information": {
                "title": "More Information",
                "description": "For questions about our cookie policy and your choices, <a href=\"#contact-page\">please contact us</a>."
            },

            "necessary": {
                "title": "Necessary",
                "description": "These cookies are essential for the operation of the website and cannot be disabled in our systems. They are usually set only in response to actions you have taken, such as setting your age."
            },
            "analytics": {
                "title": "Analytics",
                "description": "These cookies help us understand how visitors use our website by collecting anonymous information and generating reports. These cookies can be used to improve website performance and to understand which pages are popular and how visitors navigate the site."
            }
        }
    }
}